import { render } from "./EmailRegistration.vue?vue&type=template&id=3beb6920&scoped=true&ts=true"
import script from "./EmailRegistration.ts?vue&type=script&lang=ts&external"
export * from "./EmailRegistration.ts?vue&type=script&lang=ts&external"

import "./EmailRegistration.scss?vue&type=style&index=0&id=3beb6920&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3beb6920"]])

export default __exports__